<template>
  <v-card class="no-border">
    <ExchangeTabsDashboard v-model="activeExchangeTab">
      <template slot-scope="slotProps" class="card-border">
        <h2 class="title mb-32 pt-40 text-xs-center">
          Profits and unrealised losses
        </h2>
        <BaseMarketTabsDashboard
          v-model="activeTab[slotProps.exchange]"
          :exchange="slotProps.exchange"
        >
          <template slot-scope="slotProps">
            <template>
              <v-layout
                row
                wrap
                style="padding-top: 24px; padding-bottom: 20px;"
              >
                <v-flex xs12 md3>
                  <div class="text-xs-center base-currency">
                    {{ slotProps.base }}
                    <div
                      v-if="
                        recent_profits_per_base_currency &&
                          recent_profits_per_base_currency[
                            slotProps.exchange
                          ] &&
                          recent_profits_per_base_currency[slotProps.exchange][
                            slotProps.base
                          ]
                      "
                      class="display-2"
                    >
                      {{
                        recent_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ].profit_week | roundMarketsFractionalAccountValue
                      }}
                      <span class="profit-usd">
                        USD
                        {{
                          recent_profits_per_base_currency[slotProps.exchange][
                            slotProps.base
                          ].profit_week_usd | roundNumber(0)
                        }}
                        <v-icon
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 14px; margin-left: 6px; margin-bottom: 1px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.profit_worth_usd.title'),
                                $t('information.profit_worth_usd.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </span>
                    </div>
                    <div v-else class="display-2">
                      0
                      <span class="profit-usd">
                        USD 0
                        <v-icon
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 14px; margin-left: 6px; margin-bottom: 1px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.profit_worth_usd.title'),
                                $t('information.profit_worth_usd.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </span>
                    </div>
                    <div class="display-description">Last 7 days profit</div>
                  </div>
                </v-flex>
                <v-flex xs12 md3>
                  <div class="text-xs-center base-currency">
                    {{ slotProps.base }}
                    <div
                      v-if="
                        recent_profits_per_base_currency &&
                          recent_profits_per_base_currency[
                            slotProps.exchange
                          ] &&
                          recent_profits_per_base_currency[slotProps.exchange][
                            slotProps.base
                          ]
                      "
                      class="display-2"
                    >
                      {{
                        recent_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ].profit_month | roundMarketsFractionalAccountValue
                      }}
                      <span class="profit-usd">
                        USD
                        {{
                          recent_profits_per_base_currency[slotProps.exchange][
                            slotProps.base
                          ].profit_month_usd | roundNumber(0)
                        }}
                        <v-icon
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 14px; margin-left: 6px; margin-bottom: 1px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.profit_worth_usd.title'),
                                $t('information.profit_worth_usd.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </span>
                    </div>
                    <div v-else class="display-2">
                      0
                      <span class="profit-usd">
                        USD 0
                        <v-icon
                          class="vertical-align-middle icon-for-information"
                          style="font-size: 14px; margin-left: 6px; margin-bottom: 1px;"
                          @click.stop.prevent
                          @click="
                            () => {
                              infoAlert(
                                $t('information.profit_worth_usd.title'),
                                $t('information.profit_worth_usd.description')
                              );
                            }
                          "
                          >fa-info-circle</v-icon
                        >
                      </span>
                    </div>
                    <div class="display-description">Last 30 days profit</div>
                  </div>
                </v-flex>
                <v-flex
                  v-if="all_time_profits_per_base_currency"
                  xs12
                  md3
                  class="compare-box-left"
                >
                  <div
                    :class="[
                      'text-xs-center',
                      'base-currency',
                      (allocationsUnrealisedLoss[slotProps.exchange] &&
                      allocationsUnrealisedLoss[slotProps.exchange][
                        slotProps.base
                      ]
                        ? allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                        : 0) <
                      (all_time_profits_per_base_currency &&
                      all_time_profits_per_base_currency[slotProps.exchange] &&
                      all_time_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ]
                        ? all_time_profits_per_base_currency[
                            slotProps.exchange
                          ][slotProps.base].profit_all
                        : 0)
                        ? 'green-bg round-left base-currency-margins'
                        : ''
                    ]"
                  >
                    {{ slotProps.base }}
                    <div
                      v-if="
                        all_time_profits_per_base_currency &&
                          all_time_profits_per_base_currency[
                            slotProps.exchange
                          ] &&
                          all_time_profits_per_base_currency[
                            slotProps.exchange
                          ][slotProps.base]
                      "
                      class="display-2"
                    >
                      {{
                        all_time_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ].profit_all | roundMarketsFractionalAccountValue
                      }}
                    </div>
                    <div v-else class="display-2">0</div>
                    <div
                      :class="[
                        'display-description',
                        (allocationsUnrealisedLoss[slotProps.exchange] &&
                        allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ]
                          ? allocationsUnrealisedLoss[slotProps.exchange][
                              slotProps.base
                            ]
                          : 0) <
                        (all_time_profits_per_base_currency &&
                        all_time_profits_per_base_currency[
                          slotProps.exchange
                        ] &&
                        all_time_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ]
                          ? all_time_profits_per_base_currency[
                              slotProps.exchange
                            ][slotProps.base].profit_all
                          : 0)
                          ? 'green-color'
                          : ''
                      ]"
                    >
                      All time profit
                    </div>
                  </div>
                </v-flex>
                <v-flex
                  v-if="all_time_profits_per_base_currency"
                  xs12
                  md3
                  class="compare-box-right"
                >
                  <div class="image-block">
                    <img
                      v-if="
                        (allocationsUnrealisedLoss[slotProps.exchange] &&
                        allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ]
                          ? allocationsUnrealisedLoss[slotProps.exchange][
                              slotProps.base
                            ]
                          : 0) <
                          (all_time_profits_per_base_currency &&
                          all_time_profits_per_base_currency[
                            slotProps.exchange
                          ] &&
                          all_time_profits_per_base_currency[
                            slotProps.exchange
                          ][slotProps.base]
                            ? all_time_profits_per_base_currency[
                                slotProps.exchange
                              ][slotProps.base].profit_all
                            : 0)
                      "
                      class="compare-img"
                      src="/img/profit_more.svg"
                    />
                    <div v-else>
                      <img
                        v-if="
                          allocationsUnrealisedLoss[slotProps.exchange] &&
                            allocationsUnrealisedLoss[slotProps.exchange][
                              slotProps.base
                            ]
                        "
                        class="compare-img"
                        :src="
                          '/img/profit_less_' +
                            (themeDark ? 'dark' : 'light') +
                            '.svg'
                        "
                      />
                      <img
                        v-else
                        class="compare-img"
                        :src="
                          '/img/profit_more_' +
                            (themeDark ? 'dark' : 'light') +
                            '.svg'
                        "
                      />
                    </div>
                  </div>
                  <div
                    :class="[
                      'text-xs-center',
                      'base-currency',
                      (allocationsUnrealisedLoss[slotProps.exchange] &&
                      allocationsUnrealisedLoss[slotProps.exchange][
                        slotProps.base
                      ]
                        ? allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                        : 0) <
                      (all_time_profits_per_base_currency &&
                      all_time_profits_per_base_currency[slotProps.exchange] &&
                      all_time_profits_per_base_currency[slotProps.exchange][
                        slotProps.base
                      ]
                        ? all_time_profits_per_base_currency[
                            slotProps.exchange
                          ][slotProps.base].profit_all
                        : 0)
                        ? 'green-bg round-right base-currency-margins'
                        : ''
                    ]"
                  >
                    {{ slotProps.base }}
                    <div
                      v-if="
                        allocationsUnrealisedLoss[slotProps.exchange] &&
                          allocationsUnrealisedLoss[slotProps.exchange][
                            slotProps.base
                          ]
                      "
                      class="display-2"
                    >
                      {{
                        allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ] | roundMarketsFractionalAccountValue
                      }}
                    </div>
                    <div v-else class="display-2">0</div>
                    <div
                      :class="[
                        'display-description',
                        (allocationsUnrealisedLoss[slotProps.exchange] &&
                        allocationsUnrealisedLoss[slotProps.exchange][
                          slotProps.base
                        ]
                          ? allocationsUnrealisedLoss[slotProps.exchange][
                              slotProps.base
                            ]
                          : 0) <
                        (all_time_profits_per_base_currency &&
                        all_time_profits_per_base_currency[
                          slotProps.exchange
                        ] &&
                        all_time_profits_per_base_currency[slotProps.exchange][
                          slotProps.base
                        ]
                          ? all_time_profits_per_base_currency[
                              slotProps.exchange
                            ][slotProps.base].profit_all
                          : 0)
                          ? 'green-color'
                          : ''
                      ]"
                    >
                      Unrealised loss
                      <v-icon
                        class="vertical-align-middle icon-for-information"
                        style="font-size: 14px; margin-left: 6px;"
                        @click="
                          () => {
                            infoAlert(
                              $t('information.unrealised_losses.title'),
                              $t('information.unrealised_losses.description')
                            );
                          }
                        "
                        >fa-info-circle</v-icon
                      >
                    </div>
                  </div>
                </v-flex>
                <v-flex v-if="!all_time_profits_per_base_currency" xs12 md6>
                  <div class="text-xs-center pa-3">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <h3 class="loading-title">Loading profits...</h3>
                  </div>
                </v-flex>
              </v-layout>
            </template>
          </template>
        </BaseMarketTabsDashboard>
      </template>
    </ExchangeTabsDashboard>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import ExchangeTabsDashboard from "../global/ExchangeTabsDashboard";
import BaseMarketTabsDashboard from "../global/BaseMarketTabsDashboard";
import swal from "sweetalert2";

export default {
  components: {
    BaseMarketTabsDashboard,
    ExchangeTabsDashboard
  },
  data: function() {
    return {
      activeExchangeTab: 0,
      activeTab: {
        Binance: 0,
        Bittrex: 0
      }
    };
  },
  created: function() {
    if (this.$store.getters["markets/allocations"].data.length === 0) {
      this.$store.dispatch("markets/fetchAllocations");
    }
  },
  computed: {
    ...mapGetters({
      allocations: "markets/allocations",
      recent_profits_per_base_currency:
        "accountValue/recent_profits_per_base_currency",
      all_time_profits_per_base_currency:
        "accountValue/all_time_profits_per_base_currency",
      themeDark: "settings/darkmode"
    }),
    allocationsUnrealisedLoss: function() {
      let result = {};
      this.allocations.data.forEach(element => {
        if (result.hasOwnProperty(element["exchange"])) {
          if (
            result[element["exchange"]].hasOwnProperty(element["base_currency"])
          ) {
            result[element["exchange"]][element["base_currency"]] =
              result[element["exchange"]][element["base_currency"]] +
              element["unrealised_loss"];
          } else {
            result[element["exchange"]][element["base_currency"]] =
              element["unrealised_loss"];
          }
        } else {
          let item = {};
          item[element["base_currency"]] = element["unrealised_loss"];
          result[element["exchange"]] = item;
        }
      });
      return result;
    }
  },
  methods: {
    infoAlert: async function(title, text) {
      await swal({
        title: title,
        html: text,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: this.themeDark ? "swal-type-info-dark" : "swal-type-info"
      });
    }
  }
};
</script>

<style scoped>
.divider {
  position: absolute;
  height: 120px !important;
  min-height: 0px;
  color: rgba(235, 235, 245, 0.6);
  margin-top: 6px;
}
.no-border {
  box-shadow: none !important;
  background-color: inherit !important;
  border-color: inherit !important;
}
.pt-40 {
  padding-top: 40px;
}
.mb-32 {
  margin-bottom: 32px;
}
.compare-box-left {
  padding-right: 0px !important;
}
.compare-box-right {
  padding-left: 0px !important;
}

.theme--light .green-bg {
  background: rgba(126, 193, 113, 0.08);
}
.theme--light .green-color {
  color: #60a852 !important;
}
.theme--light .round-left {
  border-radius: 10px 0 0 10px;
  margin-left: 32px;
}
.theme--light .round-right {
  border-radius: 0 10px 10px 0;
  margin-right: 32px;
}
.theme--light .base-currency-margins {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}
.theme--light .compare-img {
  position: absolute;
  transform: translateX(-50%);
  z-index: 2;
  margin-top: 6px;
}
.theme--light .loading-title {
  color: #103a84;
}
.theme--light .display-2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 34px !important;
  line-height: 41px !important;
  text-align: center;
  color: #103a84;
  margin-top: 8px;
}
.theme--light .base-currency {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #103a84;
  margin-top: 20px;
  margin-bottom: 20px;
}
.theme--light .display-description {
  margin-top: 8px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #8691a4;
}
.theme--light .profit-usd {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #7395d0;
  position: absolute;
  padding-top: 20px;
  margin-left: 8px;
}
.theme--light .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #103a84;
}

.theme--light >>> .v-window {
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.09);
  border-radius: 0px 15px 15px 15px;
}

/* dark mode */

.theme--dark .loading-title {
  color: #e9e9e9;
}
.theme--dark .display-2 {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 34px !important;
  line-height: 41px !important;
  text-align: center;
  color: #e9e9e9;
  margin-top: 8px;
}
.theme--dark .base-currency {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #e9e9e9;
  margin-top: 20px;
  margin-bottom: 20px;
}
.theme--dark .display-description {
  margin-top: 8px;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: rgba(235, 235, 245, 0.6);
}
.theme--dark .profit-usd {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: rgba(235, 235, 245, 0.6);
  position: absolute;
  padding-top: 20px;
  margin-left: 8px;
}
.theme--dark .title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  color: #e9e9e9;
}
.theme--dark >>> .v-window {
  border-radius: 0px 15px 15px 15px;
  background-color: #212121;
}

.theme--dark .green-bg {
  background: rgba(126, 193, 113, 0.08);
}
.theme--dark .green-color {
  color: #60a852 !important;
}
.theme--dark .round-left {
  border-radius: 10px 0 0 10px;
  margin-left: 32px;
}
.theme--dark .round-right {
  border-radius: 0 10px 10px 0;
  margin-right: 32px;
}
.theme--dark .base-currency-margins {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}
.theme--dark .compare-img {
  position: absolute;
  transform: translateX(-50%);
  z-index: 2;
  margin-top: 6px;
}

@media (max-width: 960px) {
  .image-block {
    display: none;
  }
  .theme--light .round-left {
    border-radius: 10px;
    margin-left: 32px;
    margin-right: 32px;
  }
  .theme--light .round-right {
    border-radius: 10px;
    margin-left: 32px;
    margin-right: 32px;
  }
  .theme--dark .round-left {
    border-radius: 10px;
    margin-left: 32px;
    margin-right: 32px;
  }
  .theme--dark .round-right {
    border-radius: 10px;
    margin-left: 32px;
    margin-right: 32px;
  }
  .compare-box-left {
    padding-right: 4px !important;
  }
  .compare-box-right {
    padding-left: 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/dashboard/BaseCurrencies.vue